export default [
  [
    "song-work",
    "",
    ["create", "read", "delete"],
    {
      crud: {
        create: {
          "": "songApply2025",
        },
        read: {
          exists: "songExist2025",
          list: "songList2025",
        },
        delete: {
          "": "songDelete2025",
        },
      },
    },
  ],
  [
    "audio-work",
    "",
    ["create", "read", "delete"],
    {
      crud: {
        create: {
          "": "audioApply2025",
        },
        read: {
          exists: "audioExist2025",
          list: "audioList2025",
        },
        delete: {
          "": "audioDelete2025",
        },
      },
    },
  ],
];
